import { useApiGet } from '@sierralabs/core-ui';
export function useFindEntityData(tableName) {
    const { data, isLoading, error, get } = useApiGet(`entities/${tableName}/data`);
    return {
        entityData: data,
        isLoading,
        loadingError: error,
        getEntityData: get
    };
}
//# sourceMappingURL=useFindEntityData.js.map